import React from "react";
import GeneralStrings from "../../../strings/GeneralStrings.json";
import { Field } from "formik";
import FormikRadioGroup from "../../FormikRadioGroup/FormikRadioGroup";

const PoolHeatedStep = () => {
  const POOL_HEATED_STEP_STRINGS =
    GeneralStrings.ENROLL.FORM_LABELS.POOL_HEATED_STEP;
  const options = ["Heated", "Non-Heated"];

  return (
    <div className="step">
      <h4 className="step-header">{POOL_HEATED_STEP_STRINGS.HEADER}</h4>
      <div className="question-container">
        <Field
          className="form-group"
          name="heatedPool"
          options={options}
          component={FormikRadioGroup}
        />
      </div>
    </div>
  );
};

export default PoolHeatedStep;
